module.exports = __webpack_public_path__ + "static/media/loginVector.cba3f243.png";